<template>
  <div :class="{ 'admin-workspace': adminLayout, 'sidebar-collapsed': sidebarCollapsed }">
    <button v-if="!adminLayout" class="theme-toggle" type="button"
      :aria-pressed="String(darkMode)" aria-label="Dark Mode"
      @click="$store.commit('Layout/toggleDarkMode')">
      {{ darkMode ? '☀ Heller Modus' : '☾ Dark Mode' }}
    </button>
    <transition name="fade" mode="out-in">
      <router-view class="app-page" />
    </transition>
  </div>
</template>

<script>
export default {
  watch: {
    darkMode: {
      immediate: true,
      handler(enabled) {
        document.documentElement.setAttribute('data-theme', enabled ? 'dark' : 'light');
      },
    },
  },
  computed: {
    darkMode() { return this.$store.state.Layout.darkMode; },
    sidebarCollapsed() {
      return this.$store.state.Layout.sidebarCollapsed;
    },
    adminLayout() {
      return this.$route.meta.adminLayout && this.$store.getters['User/is_loggedin'];
    },
  },
};
</script>

<style lang="scss">
@import "./assets/scss/palette";

  html,
  body {
    overflow-x: hidden;
    padding: 0;
    margin: 0;
  }

:root {
  --app-font-family: "IBM Plex Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  --theme-text: #{$theme-text};
  --theme-primary: #{$theme-primary};
  --theme-border: #{$theme-border};
  --theme-background: #{$theme-background};
  --theme-accent: #{$theme-accent};
  --theme-surface: #{$theme-surface};
  --theme-wash: #{$theme-wash};
  --theme-hover: #{$theme-hover};
  --primary-color: var(--theme-primary) !important;
  --secondary-color: var(--theme-text)!important;
  --tertiary-color: var(--theme-background)!important;
  --primary-color-text: hsl(0, 0%, 100%)!important;
  --secondary-color-text: hsl(0, 0%, 100%)!important;
  font-family: var(--app-font-family) !important;
}

html body,
html button,
html input,
html optgroup,
html select,
html textarea,
.ql-container,
.ql-toolbar {
  font-family: var(--app-font-family);
}

// Keep short pages full-height without fixing the footer over their content.
.app-page:has(> .foota) {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  min-height: 100dvh;

  > * { flex-shrink: 0; }
  > .foota {
    margin-top: auto;
  }
}

@media (max-width: 1023px) {
  .admin-workspace > .app-page:has(> .foota) {
    min-height: calc(100vh - 60px);
    min-height: calc(100dvh - 60px);
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .15s ease;
}
.fade-enter, .fade-leave-to { opacity: 0; }
@media (prefers-reduced-motion: reduce) {
  .fade-enter-active, .fade-leave-active { transition: none; }
}

.Cookie--base {
  background-color: var(--theme-text);
  color: white;
}
.Cookie__button {
  background-color: var(--primary-color) !important;
  color: var(--primary-color-text) !important;
  font-weight: 600;
  font-size: 1em;
}

// responsive stuff
.responsive-pad {
  padding-left: 7rem !important;
  padding-right: 7rem !important;
  @media only screen and (max-width: 1216px){
    padding-left: 3.5rem !important;
    padding-right: 3.5rem !important;
  }
  @media only screen and (max-width: 768px){
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }
}
.resp-heading {
  font-family: var(--app-font-family);
  color: black;
  font-size: 2.3rem;
  @media only screen and (max-width: 768px){
    font-size: 1.5rem;
  }
}

//b-table nav styling
.b-table {
  .pagination-link.is-current {
    background-color: var(--secondary-color) !important;
    border-color: var(--secondary-color) !important;
  }
  a:hover {
    color: var(--secondary-color) !important;
  }
}

// fixed Nav
.fixed-nav {
  margin-top: 3.899rem !important;
}

// buttons
.round-anim {
  font-family: var(--app-font-family);
  border: 1px solid var(--secondary-color-text);
  box-sizing: border-box;
  border-radius: 50rem;
  background-color: transparent !important;
  outline: none;
  font-weight: 400;
  font-size: 1rem;
  margin: 0.2rem;
  padding-left: 1rem;
  padding-right: 1rem;
  color: var(--secondary-color-text) !important;
  height: 40px;
  text-align: center;
  letter-spacing:1px;
  position: relative;
  text-shadow:0;
  margin: .2rem !important;
  letter-spacing: 1px;
  cursor:
    pointer;
    transition: all 0.25s ease;
}
.round-anim:hover {
  border: 1px solid var(--primary-color) !important;
}
</style>

<style lang="scss">
@import "./assets/scss/workspace";
@import "./assets/scss/tables";
@import "./assets/scss/tabs";
@import "./assets/scss/buttons";
@import "./assets/scss/dark-mode";
</style>
